
//src/services/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyB_rcCCIOAk71o88pRdDObyOKSoCKt43MU",
  authDomain: "upsctitainscore.firebaseapp.com",
  databaseURL: "https://upsctitainscore-default-rtdb.firebaseio.com",
  projectId: "upsctitainscore",
  storageBucket: "upsctitainscore.firebasestorage.app",
  messagingSenderId: "658290246640",
  appId: "1:658290246640:web:1987cdcc9604e14bad5335",
  measurementId: "G-MHXYHCW5JH"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const database = getDatabase(app);

